import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { DrillTableDataset } from 'app/model/dataset/drill.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DrillTableDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class DrillTableDatasetAdapter extends TabularTypeDatasetAdapter<DrillTableDataset, Model.DatasetResource> {
    protected async _toResource(dataset: DrillTableDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(DrillTableDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: DrillTableDataset): Promise<DrillTableDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, DrillTableDataset.MODEL);
    }
}
